export default "__VITE_ASSET__BvI4fno6__"